//Updaint Variant Details
document.addEventListener('product:variant-change', function (evt) {
  const variant = evt.detail.variant;
  console.log(variant);

  //Enable/Disable ATC button based on availability
  if (variant.available) {
    document.getElementById('AddToCart').disabled = false;
    document.getElementById('atc_button_text').innerHTML = 'ADD TO CART';
    // Hide all Klaviyo forms when variant is available
    const klaviyoForms = document.querySelectorAll('.js-klaviyo-stock-form');
    klaviyoForms.forEach(form => {
      form.classList.add('klaviyo__stock-form--hidden');
      form.setAttribute('aria-hidden', 'true');
    });
  } else {
    document.getElementById('AddToCart').disabled = true;
    document.getElementById('atc_button_text').innerHTML = 'SOLD OUT';

    // Hide all Klaviyo forms first
    const klaviyoForms = document.querySelectorAll('.js-klaviyo-stock-form');
    klaviyoForms.forEach(form => {
      form.classList.add('klaviyo__stock-form--hidden');
      form.setAttribute('aria-hidden', 'true');
    });

    // Show the appropriate Klaviyo form for this variant
    // First try variant-specific form
    const variantKlaviyoForm = document.querySelector(
      `.js-klaviyo-stock-form[data-variant-id="${variant.id}"]`
    );
    if (variantKlaviyoForm) {
      variantKlaviyoForm.classList.remove('klaviyo__stock-form--hidden');
      variantKlaviyoForm.setAttribute('aria-hidden', 'false');
    } else {
      // Fallback to product-level form (for products with only default variant)
      const productKlaviyoForm = document.querySelector(
        '.js-klaviyo-stock-form:not([data-variant-id])'
      );
      if (productKlaviyoForm) {
        productKlaviyoForm.classList.remove('klaviyo__stock-form--hidden');
        productKlaviyoForm.setAttribute('aria-hidden', 'false');
      }
    }
  }

  // *START UPDATE BUTTON ACTIVE STATE* //

  //First make everything inactive
  const containers = document.getElementsByClassName('button-toggle');
  for (let i = 0; i < containers.length; i++) {
    containers[i].classList.remove('active');
    containers[i].firstElementChild.classList.remove('active');
  }

  const optionIndex = document.getElementById('buttonOptionIndex').value;
  //Now activate the relevant things
  document
    .querySelector(
      '[data-option-value="' + variant[`option${optionIndex}`] + '"]'
    )
    .classList.add('active');
  document
    .querySelector(
      '[data-option-value="' + variant[`option${optionIndex}`] + '"]'
    )
    .firstElementChild.classList.add('active');

  //* HIDE STUFF FOR OOS *//
  const availableForm = document.getElementById(variant.title + '--oos-form');
  if (availableForm != '') {
    if (!variant.available) {
      const oos_forms = document.getElementsByClassName('oos-form');
      for (let i = 0; i < oos_forms.length; i++) {
        oos_forms[i].style.display = 'none';
      }
      availableForm.style.marginTop = '-45px';
      availableForm.style.display = 'block';
      document.getElementsByClassName(
        'product-add-to-cart-container'
      )[0].style.display = 'none';
    } else {
      const oos_forms = document.getElementsByClassName('oos-form');
      for (let i = 0; i < oos_forms.length; i++) {
        oos_forms[i].style.display = 'none';
      }
      document.getElementsByClassName(
        'product-add-to-cart-container'
      )[0].style.display = 'block';
    }
  } else {
    const oos_forms = document.getElementsByClassName('oos-form');
    for (let i = 0; i < oos_forms.length; i++) {
      oos_forms[i].style.display = 'none';
    }
    document.getElementsByClassName(
      'product-add-to-cart-container'
    )[0].style.display = 'block';
  }
});
